import { W, H, R } from "./props";
import { drawRitual, ritualCaption, RITUAL_DURATION } from "./ritual";
import { drawHomeward, homewardCaption, HOMEWARD_DURATION } from "./homeward";
import { drawQuake, quakeCaption, QUAKE_DURATION } from "./quake";
import { drawWolves, wolvesCaption, WOLVES_DURATION } from "./wolves";
import { drawDescent, descentCaption, DESCENT_DURATION } from "./descent";
import { drawTown, townCaption, TOWN_DURATION, drawMine, mineCaption, MINE_DURATION } from "./town";
import { drawAssault, assaultCaption, ASSAULT_DURATION, drawGod, godCaption, GOD_DURATION } from "./finale";
import { drawWatcher, watcherCaption, WATCHER_DURATION, WATCHER_STING } from "./watcher";

export const DRIVE_DURATION = 13.5;
export const STING_AT = 6;
const CAPTIONS = [
  [0.8, 4.0, "The directions led deep into the mountains."],
  [4.3, 7.3, "No signal. No other cars. Just the snow."],
  [7.6, 10.3, "Was someone... standing out there?"],
  [10.6, 13.2, "Then, through the storm — the cabin."],
];
export const captionAt = (tt) => (CAPTIONS.find(([a, b]) => tt >= a && tt <= b) || [])[2] || null;

const V0 = 70, SLOW_AT = 9.5, SLOW_FOR = 3;
const offsetAt = (tt) => {
  if (tt < SLOW_AT) return V0 * tt;
  const d = Math.min(tt - SLOW_AT, SLOW_FOR);
  return V0 * SLOW_AT + V0 * (d - (d * d) / (2 * SLOW_FOR));
};
const FINAL = offsetAt(DRIVE_DURATION);
const FIGURE = offsetAt(STING_AT) + 196;
const ROAD = 150;
const wrap = (v, m) => ((v % m) + m) % m;

function scenery(ctx, off) {
  R(ctx, "#04070f", 0, 0, W, H); R(ctx, "#081020", 0, 70, W, ROAD - 70);
  for (let i = 0; i < 6; i++) {
    const x = wrap(i * 90 - off * 0.08, 540) - 90;
    for (let s = 0; s < 30; s++) R(ctx, "#0c1628", x + s * 2, 62 + Math.abs(s - 15) * 1.6, 2, ROAD);
    R(ctx, "#a9bbcc", x + 26, 62, 8, 2);
  }
  for (let i = 0; i < 14; i++) {
    const x = wrap(i * 37 - off * 0.35, 520) - 40;
    R(ctx, "#070d18", x + 7, 96, 4, ROAD - 96);
    for (let k = 0; k < 4; k++) R(ctx, "#09121f", x + 9 - (3 + k * 3), 82 + k * 9, 6 + k * 6, 9);
  }
  R(ctx, "#8ea4bb", 0, ROAD - 6, W, 6); R(ctx, "#1a1f27", 0, ROAD, W, 16); R(ctx, "#c8d6e3", 0, ROAD + 16, W, H - ROAD - 16);
  for (let x = -wrap(off, 30); x < W; x += 30) R(ctx, "#b8a24a", x, ROAD + 8, 12, 1);
}

function cabin(ctx, x) {
  if (x > W + 10) return;
  R(ctx, "#1e150d", x, 92, 80, ROAD - 92); for (let y = 96; y < ROAD; y += 7) R(ctx, "#140e08", x, y, 80, 2);
  for (let i = 0; i < 12; i++) R(ctx, "#1e150d", x - 6 + i * 4, 92 - i * 2.2, 92 - i * 8, 3);
  R(ctx, "#d9e4ee", x - 8, 90, 96, 3); R(ctx, "#d9e4ee", x + 18, 66, 44, 3);
  R(ctx, "#f59e0b", x + 12, 108, 12, 12); R(ctx, "#1e150d", x + 17, 108, 2, 12); R(ctx, "#f59e0b", x + 56, 108, 12, 12); R(ctx, "#1e150d", x + 61, 108, 2, 12);
  R(ctx, "#3a2414", x + 34, 116, 12, ROAD - 116); R(ctx, "#2a1a10", x + 52, 74, 8, 18);
}

function figure(ctx, x, tt) {
  if (x < -10 || x > W) return;
  R(ctx, "#020203", x, 104, 7, 40); R(ctx, "#020203", x + 1, 98, 5, 7); R(ctx, "#020203", x - 2, 108, 2, 22); R(ctx, "#020203", x + 7, 108, 2, 22);
  if (Math.sin(tt * 9) > -0.6) { R(ctx, "#e8f1ff", x + 2, 100, 1, 1); R(ctx, "#e8f1ff", x + 4, 100, 1, 1); }
}

function car(ctx, x, tt, moving) {
  const bob = moving && Math.sin(tt * 18) > 0.4 ? 1 : 0, y = ROAD - 4 - bob;
  const g = ctx.createLinearGradient(x + 44, 0, x + 150, 0);
  g.addColorStop(0, "rgba(255,240,190,0.38)"); g.addColorStop(1, "rgba(255,240,190,0)");
  ctx.fillStyle = g; ctx.beginPath(); ctx.moveTo(x + 44, y - 9); ctx.lineTo(x + 150, y - 30); ctx.lineTo(x + 150, y + 10); ctx.lineTo(x + 44, y - 5); ctx.fill();
  R(ctx, "#1d2a3f", x, y - 12, 46, 9); R(ctx, "#1d2a3f", x + 9, y - 21, 24, 9); R(ctx, "#d9e4ee", x + 9, y - 22, 24, 2);
  R(ctx, "#0b1220", x + 12, y - 19, 9, 6); R(ctx, "#0b1220", x + 23, y - 19, 8, 6); R(ctx, "#d9b48f", x + 25, y - 18, 3, 3);
  R(ctx, "#fde68a", x + 44, y - 10, 2, 3); R(ctx, "#dc2626", x, y - 10, 2, 3); R(ctx, "#111", x + 6, y - 4, 9, 6); R(ctx, "#111", x + 32, y - 4, 9, 6);
  R(ctx, "#555", x + 9, y - 2, 3, 2); R(ctx, "#555", x + 35, y - 2, 3, 2);
  if (moving) for (let i = 0; i < 6; i++) R(ctx, "rgba(200,214,227,0.5)", x - 4 - i * 4 - wrap(tt * 60 + i * 7, 8), y - 2 + (i % 3), 3, 1);
}

function blizzard(ctx, t) {
  for (let i = 0; i < 190; i++) {
    const sp = 0.08 + (i % 4) * 0.04;
    const x = wrap(i * 73.13 - t * sp, W), y = wrap(i * 41.7 + t * (0.03 + (i % 5) * 0.01), H);
    R(ctx, i % 4 ? "#e8f1ff" : "#9fb3c8", x, y, i % 7 === 0 ? 3 : i % 3 === 0 ? 2 : 1, 1);
  }
}

export function drawDrive(ctx, tt, now) {
  const off = offsetAt(tt), moving = tt < SLOW_AT + SLOW_FOR;
  scenery(ctx, off);
  cabin(ctx, FINAL + 210 - off);
  if (tt > STING_AT - 1.2 && tt < STING_AT + 2) figure(ctx, FIGURE - off * 1.0, tt);
  car(ctx, 92, tt, moving);
  blizzard(ctx, now);
  const v = ctx.createRadialGradient(W / 2, H / 2, 60, W / 2, H / 2, 200);
  v.addColorStop(0, "rgba(0,0,0,0)"); v.addColorStop(1, "rgba(0,0,0,0.75)"); ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 0.7 ? 1 - tt / 0.7 : tt > DRIVE_DURATION - 0.8 ? (tt - (DRIVE_DURATION - 0.8)) / 0.8 : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
}

export const CUTSCENES = {
  ritual: { duration: RITUAL_DURATION, draw: drawRitual, caption: ritualCaption },
  drive: { duration: DRIVE_DURATION, draw: drawDrive, caption: captionAt, sting: STING_AT },
  quake: { duration: QUAKE_DURATION, draw: drawQuake, caption: quakeCaption, sting: 4.4 },
  wolves: { duration: WOLVES_DURATION, draw: drawWolves, caption: wolvesCaption, sting: 14.2 },
  descent: { duration: DESCENT_DURATION, draw: drawDescent, caption: descentCaption, sting: 0 },
  town: { duration: TOWN_DURATION, draw: drawTown, caption: townCaption, sting: 0 },
  mine: { duration: MINE_DURATION, draw: drawMine, caption: mineCaption, sting: 0 },
  assault: { duration: ASSAULT_DURATION, draw: drawAssault, caption: assaultCaption, sting: 22.6 },
  godrise: { duration: GOD_DURATION, draw: drawGod, caption: godCaption, sting: 24.4, hold: true },
  homeward: { duration: HOMEWARD_DURATION, draw: drawHomeward, caption: homewardCaption, sting: 0 },
  watcher: { duration: WATCHER_DURATION, draw: drawWatcher, caption: watcherCaption, sting: WATCHER_STING },
};
